import * as React from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Zoom from '@mui/material/Zoom';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid'; import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import { isNewUi } from '../../redesign/uiMode';
import { LOOKUP_CANCEL, lookupDialogProps } from '../../redesign/shell/lookupCancel';
import { stringIsNullOrEmpty } from '../Common/Utilities';
import Tooltip from '@mui/material/Tooltip';


const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});

export class Level2Lookup extends React.Component {
	constructor(props) {
		super(props);

		this.poCode = null;
		this.noPoFlag = null;
		this.clientCode = null;

		this.inProgress = false;

		this.state = {
			level2Key: null,
			data: [],
			rowData: null
		};
		this.refresh_clickHandler = this.refresh_clickHandler.bind(this);
		this.checkbox_clickHandler = this.checkbox_clickHandler.bind(this);
		this.close_clickHandler = this.close_clickHandler.bind(this);
		this.cancel_clickHandler = this.cancel_clickHandler.bind(this);
		this.gridRef = React.createRef();
	}
	getRefreshButton = () => {
		return <IconButton
			variant="contained"
			onClick={this.refresh_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10 }}>
			<Tooltip key={1} title={'Pull data by Project Code'}>
			<RefreshIcon key={2} />
			</Tooltip>
		</IconButton>;
	}

	refresh_clickHandler(event) {
		const level2Key = this.gridRef?.current?.filterText;
		if (stringIsNullOrEmpty(level2Key)) {
			return;
		}
		this.inProgress = true;
		this.props.info.inProgress(true);

		//let functionName = "getlevel2";
		//let messageName = "Level 2";
		httpGet(`/api/invoicedocument/fetchLevel2Info?level2Key=${encodeURIComponent(level2Key)}`)
			.then(response => {
				const { status, data } = response;
				this.inProgress = false;
				this.props.info.inProgress(false);

				if (data) {
					toast.success("Level 2 info fetched successfully.");
					this.setState(prevState => {
						const exists = prevState.data.some(
							r => r.level2Key === data.level2Key
						);

						if (exists) {
							return null;
						}

						const newRow = {
							...data,
							rowId: prevState.data.length > 0
								? Math.max(...prevState.data.map(r => r.rowId)) + 1
								: 0
						};

						return {
							data: [...prevState.data, newRow]
						};
					});
				}
			})
			.catch((error) => {
				this.inProgress = false;
				this.props.info.inProgress(false);

				const status = error?.response?.status;

				if (status === 404) {
					toast.error(`No Level 2 record found for "${level2Key}".`);
					return;
				}

				const serverMessage =
					error?.response?.data?.message ||
					error?.response?.data ||
					error.message ||
					"Unexpected error occurred while fetching Level 2 info.";

				toast.error(
					`Error fetching Level 2 info${status ? ` (status ${status})` : ""
					}: ${serverMessage}`
				);
			});
	}
	componentDidUpdate() {
		//var that = this;

		if (this.props.info.poCode !== this.poCode || this.props.info.noPoFlag !== this.noPoFlag || this.props.info.clientCode !== this.clientCode) {
			this.poCode = this.props.info.poCode;
			this.noPoFlag = this.props.info.noPoFlag;
			this.clientCode = this.props.info.clientCode;

			this.inProgress = false;
			this.setState({ data: [], rowData: null });
		}

		if (this.props.info.openDialog && this.state.data.length === 0 && !this.inProgress) {
			this.inProgress = true;
			this.fetchRecords();
		}
		else if (this.props.info.level2Key !== this.state.level2Key) {
			var rowData = this.getRowData(this.props.info.level2Key);

			this.setState({ level2Key: this.props.info.level2Key, rowData: rowData });
		}
	}


	checkbox_clickHandler = (event) => {
		const clickedValue = event.target.value;
		const clickedRow = this.getRowData(clickedValue);

		if (!clickedRow) return;

		const isSameSelected =
			this.state.rowData &&
			this.state.rowData.level2Key === clickedRow.level2Key;

		//if (isSameSelected && !this.canDeselectAllSelected()) {
		//	//toast.error('Approved lines cannot be cleared. Select another Project instead.');
		//	return;
		//}

		this.setState({
			rowData: isSameSelected ? null : clickedRow
		});
	};



	close_clickHandler(event) {
		if (this.props.onClose) {
			this.props.onClose(event, this.state.rowData);
		}
	}

	canDeselectAllSelected = () => {
		const statuses = this.props.info.lineStatuses || [];

		return !statuses.some(status => {
			const s = Number(status);
			return !isNaN(s) && s >= 70 && s !== 100;
		});
	};

	fetchRecords() {
		if (this.state.data.length === 0) {
			this.props.info.inProgress(true);
			var url = "/api/lookup/level2list?noPoFlag=" + this.props.info.noPoFlag
				+ "&poCode=" + (this.props.info.poCode ? encodeURIComponent(this.props.info.poCode) : "null")
				+ "&clientCode=" + encodeURIComponent(this.props.info.clientCode);

			httpGet(url)
				.then((response) => {
					//var data = response.data;
					var data = response.data.map((e, i) => { let d = { ...e, rowId: i }; return d; })
					var rowData = data[data.findIndex(d => d.level2Key === this.props.info.level2Key)];
					this.setState({ data: data, rowData: rowData });
					this.props.info.inProgress(false);
				}).catch((error) => {
					this.props.info.inProgress(false);

					toast.error('Error fetching Project Lookup');

					this.close_clickHandler();
				});
		}
	}

	getRowData(value) {
		var data = this.state.data;

		return data[data.findIndex(d => d.level2Key === value)];
	}

	// New UI: close without applying (Cancel, ✕ and Escape).
	cancel_clickHandler(event) {
		if (this.props.onClose) {
			this.props.onClose(event, LOOKUP_CANCEL);
		}
	}

	render() {
		const newUi = isNewUi();
		const cellStyle = { paddingLeft: 8, paddingRight: 28 };
		const headerStyle = { textAlign: 'right' };

		return (
			<Dialog open={this.props.info.openDialog} TransitionComponent={Transition} fullWidth maxWidth="lg" {...lookupDialogProps(newUi)}>
				<DialogTitle>
					Select Project
						</DialogTitle>
				<DialogContent>
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							gridRef={this.gridRef}
							customcomponent={this.getRefreshButton()}
							columns={[
								{
									headerName: ' ',
									field:'chkLevel2',
									
									renderCell: rowData =>
										<Checkbox
											color="default"
											name="chk"
											checked={this.state.rowData != null && this.state.rowData !== undefined && rowData.row.level2Key === this.state.rowData.level2Key}
											value={rowData.row.level2Key}
											onClick={this.checkbox_clickHandler}
										/>,
									width: 40
								},
								{
									headerName: 'Project',
									field: 'level2Key',
									width: 50,
									flex: 1
								},
								{
									headerName: 'Description',
									field: 'level2Description',
									flex: 1
								},
								{
									headerName: 'Open Date',
									field: 'openDate',
									type: 'date',
									valueGetter: ({ value }) => (value && new Date(value)),
									flex: 1
								},
								{
									headerName: 'Customer Code',
									field: 'customerCode',
									width: 50,
									flex: 1
								},
								{
									headerName: 'Customer Name',
									field: 'customerName',
									width: 50,
									flex: 1
								},
								{
									headerName: 'Customer PO Number',
									field: 'customerPONumber',
									width: 50,
									flex: 1
								}
							

							]}
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
						/>
					</div>
				</DialogContent>
				<DialogActions>
					{newUi ? <Button onClick={this.cancel_clickHandler} data-apw2-dismiss="true">Cancel</Button> : null}
					<Button autoFocus onClick={this.close_clickHandler} color="primary">
						{newUi && this.state.rowData ? 'Select' : 'Close'}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}
